<!-- eslint-disable vue/valid-v-for -->
<template>
  <b-button-group size="sm">
    <b-button
      v-for="logoPlacement in allValues"
      @click="handleValue(logoPlacement)"
      :disabled="disabled"
      :class="{ 'highlighted' : valueDisplayed === logoPlacement }"
    >
      <i :class="`fa-light fa-${logoPlacement}`" />
    </b-button>
  </b-button-group>
</template>
<script>

function initialData() {
  return {
    valueSelected: null,
  };
}

export default {
  name: 'LogoPlacement',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: 'down-right',
    },
  },
  data() {
    return initialData();
  },
  computed: {
    allValues() {
      return ['down-right', 'down-left', 'up-right', 'up-left'];
    },
    valueDisplayed() {
      return this.valueSelected || this.value;
    },
  },
  methods: {
    handleValue(value) {
      this.valueSelected = value;
      this.$emit('updateValue', value);
    },
  },
};
</script>
<style scoped lang="scss">
.highlighted {
  background-color: $primary;
  color: $white;
}
</style>
